import { render } from "./GrupousView.vue?vue&type=template&id=f1bfcb2a"
import script from "./GrupousView.vue?vue&type=script&lang=js"
export * from "./GrupousView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__